module.exports = __webpack_public_path__ + "img/gh-31501____-36.prt.8495148c.jpg";